import {
  CATEGORY_SIZE_MAP_ENDPOINT,
  CATEGORY_FILTERS,
  GROUPS_BY_ID_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type Language, Locale } from '@/modules/language/constants';

export function fetchGroupsById() {
  return typedHttp.get(GROUPS_BY_ID_ENDPOINT, {
    cache: 'force-cache',
  });
}

export function fetchCategoryFilters({
  lang = Locale.ENUS,
}: { lang?: Language.en | Locale.ENUS } = {}) {
  return typedHttp.get(CATEGORY_FILTERS, {
    cache: 'force-cache',
    params: {
      lang,
    },
  });
}

export function fetchCategorySizeMap() {
  return typedHttp.get(CATEGORY_SIZE_MAP_ENDPOINT, {
    cache: 'force-cache',
  });
}
